// Auto-generated by splitter.py — do not regenerate; edit directly.

import React from 'react';

export const KV = ({ label, value, mono = false }) => (
  <div className="flex items-start justify-between gap-4 py-1.5">
    <span className="text-[12px] text-[#6B7280] flex-shrink-0">{label}</span>
    <span className={`text-[12.5px] text-[#1F2937] text-right ${mono ? 'font-mono text-[12px]' : ''}`}>{value}</span>
  </div>
);

